export const natures = [
    "Watermelon",
    "Grape",
    "Apple",
    "Banana",
    "Mullet",
    "Leopard",
    "Mouse",
    "Deciduous Tree", 
    "Reindeer",
    "Mango",
    "Pansy" ,
    "Dusk" ,
    "Insect" ,
    "Bedbug" ,
    "Flounder" ,
    "Whelk" ,
    "Virus" ,
    "Guinea Fowl",
    "Dromedary",
    "Aubergine" ,
    "Mosquito"
];